import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import './workspaceTheme.css';
import App from './App';
import { PopupProvider } from './components/PopupProvider';
import reportWebVitals from './reportWebVitals';
import { createCachedApiFetch } from './utils/apiFetch';
import { installActionProgressTracking } from './utils/actionProgress';
import { registerApiCacheClearer } from './utils/apiCache';
import { API_URL } from './config/api';

const nativeFetch = window.fetch.bind(window);
const cachedFetch = createCachedApiFetch(nativeFetch, API_URL);
registerApiCacheClearer(cachedFetch.clearCache);
window.fetch = (input, init = {}) => {
  const requestUrl = typeof input === 'string' ? input : input.url;
  const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
  const token = localStorage.getItem('token');
  if (token && !requestUrl.includes('/api/login')) headers.set('Authorization', `Bearer ${token}`);
  return cachedFetch(input, { ...init, headers }).then((response) => {
    if (response.status === 401 && !requestUrl.includes('/api/login')) {
      cachedFetch.clearCache();
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      window.__bqSkipRefreshPrompt = true;
      window.location.assign('/');
    }
    return response;
  });
};
installActionProgressTracking(window);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PopupProvider>
      <App />
    </PopupProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
